import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { ModalButtonWithForm } from 'components/common';
import { AchievementTemplateItemForm } from '.';

interface Props {
  achievementId: number;
  buttonText: string;
  itemAnswerableByUserLabel: string;
  itemLabel: string;
  itemMarkableByUserLabel: string;
  numberOfItems: number;
  successMessage: string;
  updateTemplate: () => Promise<void>;
}

const AchievementTemplateAddItem = ({
  achievementId,
  buttonText,
  itemAnswerableByUserLabel,
  itemLabel,
  itemMarkableByUserLabel,
  numberOfItems,
  successMessage,
  updateTemplate
}: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      const response = await api.post(
        `/admin/achievements/${achievementId}/template`,
        { template: [values] }
      );
      await updateTemplate();

      if (response.data?.isIncompleteToggled) {
        dispatch.updatePageState({
          achievement: { ...achievement, isIncompleteViewableByUser: true }
        });
      }
      dispatch.addNotice({ text: successMessage, type: 'success' });
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  const initialValues = {
    text: '',
    order: numberOfItems + 1
  };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="plus"
      buttonSize="header"
      buttonText={buttonText}
      initialValues={initialValues}
      modalActionText={messages.commonAdd}
      modalTitle={buttonText}
      modalWidth="medium"
      onSubmit={handleSubmit}
      pristineIsValid={false}
    >
      {() => (
        <AchievementTemplateItemForm
          itemAnswerableByUserLabel={itemAnswerableByUserLabel}
          itemLabel={itemLabel}
          itemMarkableByUserLabel={itemMarkableByUserLabel}
          numberOfItems={numberOfItems}
        />
      )}
    </ModalButtonWithForm>
  );
};

export default AchievementTemplateAddItem;
